// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import DateUtils from '../../../utils/DateUtils';
import Utils from '../../../utils/Utils';

import Hour from './Hour';
import Minute from './Minute';

class HourChooser extends Component {

  static defaultProps = {
    disabled: false,
    withEndOfDay: false
  }

  static propTypes = {
    // timestamp as ms.
    defaultValue: PropTypes.number.isRequired,

    // param: number (Timestamp as ms)
    onChange: PropTypes.func.isRequired,

    disabled: PropTypes.bool,

    withEndOfDay: PropTypes.bool,
  };

  state = {
    selectedHour: null,
    identifier: `hour_chooser_${Utils.generateUID()}`
  };

  // --
  displayChoseHourMenu = (event: Object) => {
    event.preventDefault();

    if (!this.props.disabled) {
      this.toggleMenu();
    }
  };

  onHourSelected = (hour: number) => {
    this.setState({
      selectedHour: hour
    });
  };

  onMinuteSelected = (minute: number) => {
    this.onClose();

    // handle 23:59 and 00:00
    if ((this.state.selectedHour === 23 && minute === 59) || (this.props.withEndOfDay && this.state.selectedHour === 0 && minute === 0)) {
      this.props.onChange(86340000);
    } else {
      this.props.onChange(DateUtils.getMsTimestampForHourAndMinute(this.state.selectedHour, minute));
    }
  };

  onClose = (e: Object) => {
    if (!_.isUndefined(e)) {
      e.preventDefault();
    }
    this.toggleMenu();
    this.setState({
      selectedHour: null
    });
  };

  toggleMenu() {
    const selector = $(`#${this.state.identifier}`);

    if (!selector.parent().hasClass('open')) { // hide other hour chooser if displayed.
      $('.hour_chooser').removeClass('open');
    }

    // toggle the dropdown.
    selector.parent().toggleClass('open');
  }

  // -- renderers

  renderHoursList() {
    const list = [];

    const defaultValueHour = DateUtils.getHourFromMsHourTimestamp(this.props.defaultValue);

    for (let i = 0; i < 24; i++) {
      const isSelected = defaultValueHour === i;

      list.push(
        <Hour
          key={`hour_${i}`}
          value={i}
          onChange={this.onHourSelected}
          isSelected={isSelected}
        />
      );
    }

    return list;
  }

  renderMinutesList() {
    const list = [];

    for (let i = 0; i <= 45; i += 15) {
      const isSelected = DateUtils.getMinuteFromMsHourTimestamp(this.props.defaultValue) === i;

      list.push(
        <Minute
          key={`minute_${i}`}
          value={i}
          onChange={this.onMinuteSelected}
          isSelected={isSelected}
        />
      );
    }

    if (this.props.withEndOfDay && this.state.selectedHour === 23) {
      const isSelected = DateUtils.getMinuteFromMsHourTimestamp(this.props.defaultValue) === 59;

      list.push(
        <Minute
          key={`minute_${59}`}
          value={59}
          onChange={this.onMinuteSelected}
          isSelected={isSelected}
        />
      );
    }

    return list;
  }

  renderButtonView() {
    const label = DateUtils.getFormattedHourWithMsHour(this.props.defaultValue);

    if (this.props.disabled) {
      return (
        <span
          className="form-control disabled"
        >
          {label}
        </span>
      );
    }

    return (
      <span
        className="form-control dropdown-toggle"
        id={this.state.identifier}
        onClick={this.displayChoseHourMenu}
        aria-haspopup="true"
        aria-expanded="false"
      >
        {label}
      </span>
    );

  }

  render() {
    let listView = [];
    let title = '';

    if (_.isNull(this.state.selectedHour)) { // display hours
      listView = this.renderHoursList();
      title = 'Sélectionner une heure';
    } else { // display minutes
      listView = this.renderMinutesList();
      title = 'Sélectionner les minutes';
    }

    return (
      <span className="dropdown hour_chooser">
        {this.renderButtonView()}

        <div
          className="dropdown-menu pull-right"
          aria-labelledby={this.state.identifier}
        >
          <div className="col-xs-12">
            <div className="row">
              <h3 className="text-center col-xs-12">
                {title}
              </h3>

              <div className="top-buffer-20">
                {listView}
              </div>

              <div className="col-xs-12 text-center">
                <button
                  className="btn btn-default"
                  onClick={this.onClose}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }

}

export default HourChooser;



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/HourChooser/index.js